import { getPageLocation } from 'selectors'
import { getAllResultsNextRequestUrl } from './helpers'
import { rest } from 'services'
import { getRecordsAndSortOptionsFromData } from './selectors'
import isEmpty from 'lodash/isEmpty'

export const preLoadItems = ({
  setPreLoaderOptions,
  setNoNewRecords,
  index
}) => async (dispatch, getState) => {
  const { search, pathname } = getPageLocation(getState())

  try {
    const { data } = await rest.get(getAllResultsNextRequestUrl({ search, pathname, index }))
    const { records, sortOptions, lastRecNum } = getRecordsAndSortOptionsFromData(data)
    if (records && !isEmpty(records)) {
      setPreLoaderOptions({
        isViewAll: true,
        preLoadedSortOptions: sortOptions,
        preLoadedRecords: records,
        recordIndex: lastRecNum,
        noNewRecords: false
      })
    } else {
      setNoNewRecords(true)
    }
  } catch (e) {
    setNoNewRecords(true)
    console.log(e)
  }
}
